import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RoleComponent } from './role.component';
import { RoleRoutingModule } from './role-routing.module';
import { FormsModule } from '@angular/forms';
import { RoleResolve } from './role.resolve';
import { EditRoleModule } from './edit/edit-role.module';
import { AddRoleModule } from './add/add-role.module';
import { SharedModule } from '../../../shared/shared.module';
import { AppMaterialModule } from '../../../shared/appMaterial/app-material.module';
import { ListGridModule } from '../../../shared/listGrid/listGrid.module';

@NgModule({
  imports: [
    CommonModule,
    RoleRoutingModule,
    FormsModule,
    AppMaterialModule,
    SharedModule,
    AddRoleModule,
    EditRoleModule,
    ListGridModule,
  ],
  declarations: [RoleComponent],
  exports: [RoleComponent],
  providers: [RoleResolve],
})
export class RoleModule {}
